<template>
    <div>
        <TransitionFade>
            <div class="absolute left-0 top-0 w-full h-full backdrop-blur-xl" v-if="searchValue"></div>
        </TransitionFade>

        <!-- Filters -->
        <Filters
            :state="openFilters"
            @close="closeFiltersMenu"
            @search="performAdvancedSearch"
        />

        <div class="px-5 absolute top-1/2 left-1/2 w-full max-w-2xl transform -translate-x-1/2 -translate-y-1/2 z-[36]">
            <form action="." @submit.prevent="handleSubmit" class="w-full rounded-md overflow-hidden">
                <MoleculePreviewInput v-model="searchValue"/>

                <div
                    class="absolute left-1/2 text-sm max-w-2xl -translate-x-1/2 w-full text-right px-6"
                    :class="searchValue ? 'top-[102%]' : 'top-[105%]'"
                >
                    <button type="button" class="text-white underline" @click="openFiltersMenu">
                        {{ $t('search.advanced_search') }}
                    </button>
                </div>

                <transition name="fadeHeight" mode="out-in">
                    <div class="results" v-if="searchValue">
                        <MoleculePreviewRecent
                            :recent-searches="recentSearches"
                        />

                        <MoleculePreviewResult
                            :data="artists" :title="$t('search.people')"
                            :search-value="searchValue"
                        />

                        <MoleculePreviewResult
                            :data="events" :title="$t('search.artworks')"
                            :search-value="searchValue"
                        />
                    </div>
                </transition>
            </form>
        </div>
    </div>
</template>

<script>
import TransitionFade from "../../../transitions/TransitionFade.vue";
import {mapActions} from "vuex";
import debounce from 'lodash/debounce';
import MoleculePreviewInput from "../molecules/MoleculePreviewInput.vue";
import MoleculePreviewRecent from "../molecules/MoleculePreviewRecent.vue";
import MoleculePreviewResult from "../molecules/MoleculePreviewResult.vue";
import Filters from "./OrganismFilters.vue";
import {pickBy} from "lodash";

export default {
    name: "OrganismSearchEngine",
    components: {
        Filters,
        MoleculePreviewResult, MoleculePreviewRecent, MoleculePreviewInput, TransitionFade
    },
    data(){
        return {
            searchValue: "",
            artists: null,
            events: null,
            openFilters: false
        }
    },
    computed: {
        recentSearches() {
            return JSON.parse(localStorage.getItem("recentSearches")) || [];
        },
    },
    methods: {
        ...mapActions('people', {
            searchPeoples: 'search'
        }),
        ...mapActions('event', {
            searchEvents: 'search'
        }),
        ...mapActions('project', {
            searchProjects: 'search'
        }),

        openFiltersMenu() {
            document.querySelector('body').style.overflow = 'hidden';
            this.openFilters = true
        },

        closeFiltersMenu(){
            document.querySelector('body').style.overflow = '';
            this.openFilters = false
        },

        async performSearch() {
            const peopleResults = await this.searchPeoples({ query: this.searchValue });
            const eventResults = await this.searchEvents({ query: this.searchValue });
            const projectResults = await this.searchProjects({ query: this.searchValue });

            const combinedResults = [...eventResults, ...projectResults];

            this.artists = peopleResults.slice(0, 3).map(result => result.name);
            this.events = combinedResults.slice(0, 3).map(result => result.name || result.title);
        },

        performAdvancedSearch(){
            const { periodStart, periodEnd, selectedSubcategories } = this.$route.query;
            const subcategoriesParams = selectedSubcategories ? selectedSubcategories.split(',').map(Number) : [];

            const queryParams = {
                q: encodeURIComponent(this.searchValue),
                periodStart: periodStart || undefined,
                periodEnd: periodEnd || undefined,
                selectedSubcategories: subcategoriesParams.length ? subcategoriesParams.join(',') : undefined,
            };

            // Remove undefined values from the queryParams
            const filteredQueryParams = pickBy(queryParams);

            this.$router.push({ path: '/search', query: filteredQueryParams });
        },

        handleSubmit(){
            const encodedSearch = encodeURIComponent(this.searchValue);

            this.$router.push({ path: `/search?q=${encodedSearch}` });
        }
    },
    watch: {
        searchValue(newVal) {
            this.debouncedSearch();
        },
    },
    mounted() {
        this.debouncedSearch = debounce(this.performSearch, 300);
    }
}
</script>

<style scoped>
.results{
    background: rgba(0, 0, 0, 0.50);
    box-shadow: 0 11px 28px 0 rgba(0, 0, 0, 0.11);
    backdrop-filter: blur(80px);
    backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
}

.fadeHeight-enter-active, .fadeHeight-leave-active {
    transition: all 0.5s;
    max-height: 1000px;
}
.fadeHeight-enter, .fadeHeight-leave-to
{
    opacity: 0;
    max-height: 0;
}
</style>
